export const useCacheStore = defineStore('cache.store', () => {
  const cachedRequests = ref<Record<string, number>>({})

  const set = ({ url, item }: { url: string; item: number }) => {
    cachedRequests.value[url] = item
  }

  const deleteCache = (key: string) => {
    delete cachedRequests.value[key]
  }

  return {
    cachedRequests,
    set,
    deleteCache,
  }
})
